import React from "react";
import { Button, Collapse, Skeleton, Tag } from "antd";
import { CaretRightOutlined, ExportOutlined } from "@ant-design/icons";
import LazyMount from "./LazyMount.jsx";

const SpinachDashboardGroups = ({
  expandedGroups,
  handleGroupChange,
  filteredByType,
  renderGreenhouseTable,
  groupConfig,
  groupedGreenhouses,
  userData,
  setExportModalVisible,
  isLoading,
  greenHouseTableLoading,
}) => {
  const renderGroupHeader = (type) => (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <Tag color={groupConfig[type].color} className="m-0 w-fit">
          {groupConfig[type].label}
        </Tag>
        <span
          style={{ color: groupConfig[type].color }}
          className="text-xs md:text-sm leading-tight whitespace-normal self-center"
        >
          {groupConfig[type].description} (
          {groupedGreenhouses?.[type]?.length || 0})
        </span>
      </div>
      {userData?.is_superuser && type === 4 && (
        <Button
          size="small"
          onClick={() => setExportModalVisible(true)}
          disabled={isLoading || greenHouseTableLoading}
        >
          Export
          <ExportOutlined />
        </Button>
      )}
    </div>
  );

  return (
    <Collapse
      bordered={false}
      destroyOnHidden
      activeKey={expandedGroups}
      onChange={handleGroupChange}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      items={[1, 2, 0, 3, 4].map((type) => ({
        key: String(type),
        label: renderGroupHeader(type),
        children: (
          <div className="grid gap-6 min-w-0">
            {filteredByType[type].map((ghName) => (
              <LazyMount
                key={ghName}
                placeholder={
                  <Skeleton
                    active
                    paragraph={{ rows: 4 }}
                    style={{
                      padding: 12,
                      border: "1px solid #f0f0f0",
                      borderRadius: 8,
                    }}
                  />
                }
              >
                <div className="mb-6 min-w-0">
                  {renderGreenhouseTable(ghName)}
                </div>
              </LazyMount>
            ))}
          </div>
        ),
        style: {
          background: "#fff",
          border: `1px solid ${groupConfig[type].color}`,
          borderRadius: 8,
        },
        className: "sm:mb-4 md:mb-6 mb-8 last:mb-0",
        id: `collapse-group-${type}`,
      }))}
    />
  );
};

export default SpinachDashboardGroups;
